import React from "react";
import styled from "styled-components";

interface Props {}

const EmailItemLoader = (props: Props) => {
  return (
    <Wrapper>
      <div className="sk-container">
        <div className="wrapper d-flex">
          <div className="content-div">
            <div className="skeleton-box plus-icon-wrapper" />
            <div className="blog-image">
              <div className="skeleton-box img1" />
              <div className="right-images">
                <div className="skeleton-box img2" />
                <div className="skeleton-box img3" />
              </div>
            </div>
            <div className="skeleton-box asset-badge" />
            <div className="content padding-right-xl padding-left-md">
              <div className="content-inner-wrapper">
                <h4 className="skeleton-box title margin-bottom-xs">{""}</h4>
              </div>
              <div className="desc">
                <span className="skeleton-box published-time padding-sm">{}</span>
                <span className="skeleton-box tags padding-sm">{}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default EmailItemLoader;

const Wrapper = styled.div`
  overflow: hidden;
  margin-top: 20px;
  @-webkit-keyframes shimmer {
    100% {
      -webkit-transform: translateX(100%);
      transform: translateX(100%);
    }
  }

  @keyframes shimmer {
    100% {
      -webkit-transform: translateX(100%);
      transform: translateX(100%);
    }
  }
  .sk-container {
    width: 100%;
    background-color: #ffffff;
    padding: 0px;
    margin: 0;
    .clear {
      clear: both;
    }
    .skeleton-box {
      display: inline-block;
      height: 1em;
      position: relative;
      overflow: hidden;
      background-color: #e9e9e9;
      &.radius-1 {
        border-radius: 10px;
      }
      &:after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        -webkit-transform: translateX(-100%);
        transform: translateX(-100%);
        background-image: -webkit-gradient(
          linear,
          left top,
          right top,
          color-stop(0, rgba(255, 255, 255, 0)),
          color-stop(20%, rgba(255, 255, 255, 0.2)),
          color-stop(60%, rgba(255, 255, 255, 0.5)),
          to(rgba(255, 255, 255, 0))
        );
        background-image: linear-gradient(
          90deg,
          rgba(255, 255, 255, 0) 0,
          rgba(255, 255, 255, 0.2) 20%,
          rgba(255, 255, 255, 0.5) 60%,
          rgba(255, 255, 255, 0)
        );
        -webkit-animation: shimmer 2s infinite;
        animation: shimmer 2s infinite;
        content: "";
      }
    }
    .wrapper {
      background-color: #f7f7f7;
      border-radius: 10px;
      padding-left: 13px;
      padding-right: 13px;
      padding-top: 6px;
      padding-bottom: 6px;
      position: relative;
      // min-width: 420px;
      .content-div {
        padding-top: 0.5em;
        padding-bottom: 0.5em;
        padding-left: 0px;
        padding-right: 0px;
        display: flex;
        align-items: center;
        width: 100%;
        .asset-badge {
          border: none;
          height: 24px;
          width: 44px;
          border-radius: 15px;
          color: #c21e1e;
          display: flex;
          justify-content: center;
          align-items: center;
          position: absolute;
          right: 20px;
          top: 25px;
        }
        .content {
          display: flex;
          flex-direction: column;
          justify-content: center;
          overflow-wrap: anywhere;
          flex-grow: 1;
        }
        .desc {
          color: #7e7e7e;
        }
        .plus-icon-wrapper {
          display: flex;
          align-items: center;
          margin-right: 10px;
          cursor: pointer;
          width: 25px;
          height: 30px;
          border-radius: 5px;
        }

        .blog-image {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100px;
          height: 80px;
          .img1 {
            height: 70px;
            width: 52px;
            border-radius: 6px 0px 0px 6px;
            margin-right: 2px;
          }
          .img-bg {
            background-position: center center;
            background-size: cover;
            background-repeat: no-repeat;
          }
          .right-images {
            .img-bg {
              background-position: center center;
              background-size: cover;
              background-repeat: no-repeat;
            }
            display: flex;
            flex-direction: column;
            .img2 {
              height: 34px;
              width: 39px;
              border-radius: 0px 6px 0px 0px;
              margin-bottom: 2px;
            }
            .img3 {
              height: 34px;
              width: 39px;
              border-radius: 0px 0px 6px 0px;
            }
          }
        }
        .title {
          margin: 0;
          margin-bottom: 15px;
          padding: 0;
          border-radius: 5px;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          width: 75%;
          height: 25px;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            font-weight: normal;
          }
        }
        .published-time {
          border-radius: 5px;
          width: 60px;
          height: 20px;
        }
        .tags {
          width: 60px;
          height: 20px;
          margin-left: 20px;
          border-radius: 5px;
        }
        .Blog-menu-icon {
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .Blog-menu-icon img {
          cursor: pointer;
          .ant-popover .ant-popover-content .ant-popover-inner {
            border-radius: 10px;
          }
        }
      }
    }
  }
`;
